module.exports = __webpack_public_path__ + "img/infrastructureOperation.f1c3e8cd.svg";